<nav aria-label="Domein navigatie">
  <ul class="domain-navigation__list list-unstyled">
    @for (navigationItem of navigationItems(); track navigationItem.name) {
      @if (navigationItem.path && navigationItem.name) {
        <li class="domain-navigation__list-item">
          <wl-nav-link
            [active]="navigationItem.active"
            [linkTitle]="navigationItem.name"
            [linkUrl]="navigationItem.path"
            (clicked)="navigate.emit()"
          />
        </li>
      }
    }
  </ul>
</nav>
